

































































import { Vue, Component } from 'vue-property-decorator';
import AvaivaledVue from '@/components/avaivaled.vue';
import Axios from 'axios';
import { DeleteTagRequest } from '@/models/tagRequest';
import { TagInfo, TagListResponse } from '@/models/tagResponse';
import { Tag } from '@/models/tag';

@Component
export default class TagList extends AvaivaledVue {
  private keyword: string = '';

  private tagList: TagInfo[] = [];

  private loading: boolean = false;
  private showSearchCondition: boolean = true;

  get filteredList(): TagInfo[] {
    if (!this.keyword) {
      return this.tagList;
    }
    return this.tagList.filter((tag) => tag.tagName.includes(this.keyword));
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private async mounted() {
    await this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    this.loading = true;
    try {
      const response = await Axios.get<TagListResponse>('/api/Tag/SearchList').catch((error) => {
        throw new Error('タグ一覧の取得に失敗しました。');
      });
      this.tagList = response.data.tagList;
    } catch (error) {
      this.tagList = [];
    }
    this.loading = false;
  }

  private onShowStudentList(row: TagInfo) {
    this.$store.state.student.searchCondition.tagList = [{
      id: row.tagId,
      name: row.tagName,
    }] as Tag[];
    this.$router.push({ name: 'StudentList' });
  }

  private async onDelete(row: TagInfo) {
    const tagId = row.tagId;
    const tagName = row.tagName;
    try {
      await this.$confirm(`タグ：<strong>${tagName}</strong><br>を全ての生徒から削除します。よろしいですか？`, 'タグ削除', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      const request: DeleteTagRequest = {
        tagId
      };
      await Axios.post('/api/Tag/DeleteTag', request).catch((error) => {
        throw new Error('タグの削除に失敗しました。');
      });

      this.loadData();

      this.$notify({
        title: '削除完了',
        message: `タグ：<strong>${tagName}</strong><br>を削除しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right',
      });
    }
  }
}
